import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScorecardDashboard from './ScorecardDashboard';
import StoreDetail from './components/store-detail/StoreDetail';
import RegionComparison from './components/region-comparison/RegionComparison';
import ScorecardSettings from './components/settings/ScorecardSettings';

const Scorecard = () => {
  return (
    <Routes>
      <Route path="/" element={<ScorecardDashboard />} />
      <Route path="store/:storeId" element={<StoreDetail />} />
      <Route path="regions" element={<RegionComparison />} />
      <Route path="settings" element={<ScorecardSettings />} />
    </Routes>
  );
};

export default Scorecard; 